<template lang="pug">
v-img(
  src="/img/logos/sysafra_logo_dark.png"
  :position="(left ? 'left' : 'center') + ' center'"
  contain
  :height="h"
  :width="w"
  :max-height="mh"
  :max-width="mw"
  :min-height="h"
  :min-width="w"
)
</template>

<script>
export default {
  name: "LogoSySafra",
  props: {
    left: {
      type: Boolean,
      default: () => false
    },

    h: {
      type: Number,
      default: 36
    },

    w: {
      type: Number,
      default: 216
    },

    mh: {
      type: Number,
      default: 36
    },

    mw: {
      type: Number,
      default: 216
    }
  }
};
</script>
